export const TELIA_PLAY_GET_VAID_FROM_ADDRESS = "TELIA_PLAY_GET_VAID_FROM_ADDRESS";
export const TELIA_PLAY_SEARCH_ADDRESSES = "TELIA_PLAY_SEARCH_ADDRESSES";
export const TELIA_PLAY_SELECT_PACKAGE = "TELIA_PLAY_SELECT_PACKAGE";
export const TELIA_PLAY_SET_PERSONAL_DETAILS = "TELIA_PLAY_SET_PERSONAL_DETAILS";
export const TELIA_PLAY_SET_CONTACT_INFO = "TELIA_PLAY_SET_CONTACT_INFO";
export const TELIA_PLAY_SUBMIT_ORDER = "TELIA_PLAY_SUBMIT_ORDER";
export const TELIA_PLAY_CUSTOMER_SUBMISSION_STARTED = "TELIA_PLAY_CUSTOMER_SUBMISSION_STARTED";
export const TELIA_PLAY_CUSTOMER_SUBMISSION_FINISHED = "TELIA_PLAY_CUSTOMER_SUBMISSION_FINISHED";
export const TELIA_PLAY_CLEAR_PACKAGE_UNAVAILABLE = "TELIA_PLAY_CLEAR_PACKAGE_UNAVAILABLE";
export const TELIA_PLAY_SET_MOCK_ADDRESS = "TELIA_PLAY_SET_MOCK_ADDRESS";
export const TELIA_PLAY_SELECT_MOCK_ADDRESS = "TELIA_PLAY_SELECT_MOCK_ADDRESS";
